import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import LDBOverviewTable from "./LDBOverviewTable";
import useBorowerLoanDetail from "../../../../hooks/useBorowerLoanDetail";
import LDBDetailTable from "./LDBDetailTable";
import { roleType } from "../../../../Utils/constant";
import { Button } from "react-bootstrap";
import PopupWrapper from "../../../../components/PopupWrapper";
import FormBox from "../../../../components/FormBox/FormBox";
import { useForm } from "react-hook-form";
import LDPBorrower from "../../BorrowerDashboard/LDPBorrower";
// import classes from "../AllLoans/LoanDetails.module.css";
import classes from "../AllLoans/LoanDetails.module.css";
import CustomBreadCrumbs from "../../../../components/CustomBreadCrumbs";
import { BlurWrapperWithSpan } from "../../../../Utils/CustomComponent";

const LoanDetails = () => {
  const navigate = useNavigate();
  const accountId = useSelector((state) => state.account.lenderId);
  const { loanDetails } = useBorowerLoanDetail(accountId);
  const [showPopup, setShowPopup] = useState(false);
  const selectedRole = useSelector((state) => state.account.selectedRole.value);
  const selectedAccount = useSelector((state) => state.account.selectedAccount);
  const [isPastMaturity, setIsPastMaturity] = useState(false);
  const { isLargeDevice } = useSelector((state) => state.RS_Sidebar);
  const showTermsPopup = useSelector((state) => state.dashboard.showTermsPopup);

  const isPaidOffAccount = JSON.parse(
    localStorage?.getItem("accessed_user")
  ).account?.filter(
    (data) =>
      data.type === selectedRole &&
      data.recid === selectedAccount?.value &&
      data.paidoff_yn?.toLowerCase() === "y"
  )?.length
    ? "Paid Off"
    : "";

  const newLoanStatus =
    loanDetails?.loanTerm?.loanStatus + "," + isPaidOffAccount;

  const loanStatusArr = newLoanStatus
    ?.split(",")
    ?.filter((item) => item !== "");

  const hasLoanStatus = loanStatusArr?.length ? true : false;

  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(";").shift();
  }

  useEffect(() => {
    const res = getCookie("accepted_terms_of_service");
    const newRes = res ? JSON.parse(res) : [];
    if (showTermsPopup) {
      if (newRes?.includes(selectedAccount?.value)) {
        setShowPopup(false);
      } else {
        setShowPopup(true);
      }
    }
  }, [selectedAccount?.value]);

  const checkLoanMaturity = () => {
    const today = new Date();
    const maturityDate = new Date(
      loanDetails?.loanOverview?.["Loan Maturity Date"]
    );
    const stopDate = new Date(loanDetails?.loanOverview?.["Loan Stop Date"]);

    if (today > maturityDate && today > stopDate) {
      setIsPastMaturity(true);
    } else {
      setIsPastMaturity(false);
      navigate(`/ach-payment`);
    }
  };

  return (
    <div>
      {/* <TermsOfService
        showPopup={showPopup}
        setShowPopup={setShowPopup}
        selectedRole={selectedRole}
        selectedAccount={selectedAccount}
        getCookie={getCookie}
        isLargeDevice={isLargeDevice}
      /> */}
      <section
        className="rounded container-fluid"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        {/* Breadscrumb Below */}
        {/* <div className="p-3 pb-0  mt-1">
          
        </div> */}
        <div className="p-3 pb-0  mt-1">
          {/* <div>
            <ul className={classes.unorderedList}>
              <li>Dashboard</li>
              <li>
                <span className={classes.spanMargin}>\</span>
              </li>
              <li className={classes.breadcrumbColor}>Loan Details</li>
            </ul>
          </div> */}
          {/* <div className="mt-1">
            <CustomBreadCrumbs
              crumbs={[
                { title: "Dashboard", link: "/borrower-dashboard-two" },
                { title: "Loan Details" },
              ]}
            />
          </div> */}
          <article className="container-fluid">
            <div className="p-3 pb-0  mt-1">
              <h6>
                <span
                  className="linkClick"
                  role="button"
                  onClick={() => navigate("/borrower-dashboard-two")}
                >
                  Dashboard
                </span>{" "}
                <span
                  className="linkClick"
                  role="button"
                  onClick={() => navigate("/loans")}
                >
                 / Loans
                </span>{" "}
                / Loan details -{" "}
                <BlurWrapperWithSpan>
                  {loanDetails?.borrowOverview?.["Account Number"]}
                </BlurWrapperWithSpan>
              </h6>
            </div>
          </article>
          {/* <h4 className="my-5">Loan Details</h4> */}
          <LDPBorrower />
          {/* {loanDetails?.loanTerm?.loanheader1 && (
            <div
              style={{
                borderRadius: "8px",
                padding: "15px",
                margin: "20px 4px",
                background: "#fff",
              }}
              className="loan-details row"
            >
              <div className="mb-5">
                <BlurWrapperWithSpan>
                  <h5 className="col-sm-12">
                    {loanDetails.loanTerm?.loanheader1}
                  </h5>
                  <h5 className="col-sm-12 mb-0">
                    {loanDetails.loanTerm?.loanheader2}
                  </h5>
                </BlurWrapperWithSpan>
              </div>

              {hasLoanStatus && (
                <div className="mb-5 alert alert-yellow bg-yellow d-flex gap-5">
                  {loanStatusArr.map((item) => (
                    <div className="px-5 rounded-pill border-1 border bg-grey">
                      <strong className="">{item}</strong>
                    </div>
                  ))}
                </div>
              )}
              <div className="col-lg-8 col-sm-12">
                {loanDetails?.loanTerm?.achStatus && (
                  <div className="mb-5 alert alert-danger">
                    <strong>{loanDetails.loanTerm?.achStatus}</strong>
                  </div>
                )}
                {loanDetails?.loanTerm?.achInfo1 && (
                  <div className="mb-5">
                    <button
                      className={`btn btn-primary text-white ${
                        !isLargeDevice ? "w-100" : ""
                      } make-payment-button`}
                      onClick={checkLoanMaturity}
                    >
                      {loanDetails?.loanTerm?.achInfo1}
                    </button>
                  </div>
                )}
                <LDBOverviewTable
                  data={loanDetails.borrowOverview}
                  isBorrowerOverview={true}
                  className={
                    "grid-item-borrower gap-20 p-4 custom-border rounded loan-details-borrower-section"
                  }
                  style1={true}
                  isLargeDevice={isLargeDevice}
                />
              </div>
              <div className="col-lg-4 col-sm-12">
                <LDBOverviewTable
                  data={loanDetails.loanOverview}
                  isBorrowerOverview={false}
                  className={
                    "p-4 custom-border rounded d-block loan-details-borrower-loan-section"
                  }
                  isLargeDevice={isLargeDevice}
                />
              </div>
            </div>
          )} */}
          {/* <LDBDetailTable isLargeDevice={isLargeDevice} /> */}
        </div>
      </section>
      <PastMaturityPopup
        isPastMaturity={isPastMaturity}
        setIsPastMaturity={setIsPastMaturity}
      />
    </div>
  );
};

export default LoanDetails;

const TermsOfService = ({
  showPopup,
  setShowPopup,
  selectedRole,
  selectedAccount,
  getCookie,
  isLargeDevice,
}) => {
  const { register, handleSubmit, watch, setValue } = useForm();
  const checkbox = watch("accept");

  const onSubmit = async (data) => {
    setShowPopup(false);
    // const res = localStorage.getItem("accepted_terms_of_service");
    // const arr1 = res ? JSON.parse(res) : [];
    // arr1.push(selectedAccount?.value);

    // localStorage.setItem("accepted_terms_of_service", JSON.stringify(arr1));

    function setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = `; expires=${date.toUTCString()}`;
      }
      document.cookie = `${name}=${value || ""}${expires}; path=/`;
    }

    const res = getCookie("accepted_terms_of_service");
    const arr1 = res ? JSON.parse(res) : [];
    arr1.push(selectedAccount?.value);

    // Set the cookie with the updated value, with an expiration of 100 years (essentially infinite)
    setCookie("accepted_terms_of_service", JSON.stringify(arr1), 365 * 100);
  };

  return (
    <div>
      {selectedRole === roleType.borrower && (
        <PopupWrapper
          title="Terms of Service"
          extraClass={`${isLargeDevice ? "width-800" : ""}`}
          Component={
            <div>
              <form>
                <FormBox
                  options={checkingFormArr}
                  register={register}
                  watch={watch}
                  setValue={setValue}
                />
                <Button
                  className="text-white mt-5"
                  onClick={handleSubmit(onSubmit)}
                  disabled={!checkbox}
                >
                  Accept
                </Button>
              </form>
            </div>
          }
          toShow={showPopup}
          closeEventHandler={() => {
            setShowPopup(false);
          }}
        />
      )}
      <style>
        {`.span-color span {
        color: black
     }
    `}
      </style>
    </div>
  );
};

const PastMaturityPopup = ({ isPastMaturity, setIsPastMaturity }) => {
  return (
    <div>
      <PopupWrapper
        title=""
        extraClass="width-800"
        Component={
          <div className="alert alert-error">
            Your loan is past maturity so you cannot make an ACH payment at this
            time, please contact your lender.
          </div>
        }
        toShow={isPastMaturity}
        closeEventHandler={() => {
          setIsPastMaturity(false);
        }}
      />
    </div>
  );
};

const checkingFormArr = [
  {
    type: "content",
    content: (
      <div className>
        <a
          href="https://superiorloanservicing.com/terms-of-service"
          target="_blank"
        >
          Click here to read our Terms of Service
        </a>
        <p className="pt-3">
          Please click on the checkbox to agree, then click submit.
        </p>
      </div>
    ),
  },
  {
    title: "Agree",
    field: "accept",
    type: "checkbox",
  },
];
